import axios from "axios";
import { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { AuthContext } from "context/AuthContext";
import useOpenSnackbar from "custom-hooks/snacbar/useOpenSnackbar";

// Fetch public key
export async function fetchPublicKey() {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/public-key`);
  // console.log('Public key fetched: ', response.data);
  return response.data.data.publicKey;
}

export function useLogin() {
  const { signIn } = useContext(AuthContext);
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
  useOpenSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const [loginData, setLoginData] = useState({});

  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/auth/login`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        signIn(response);
      },
      onError: (error)=>{
        openSnackbar('error', error?.response?.data?.message)
        if(error?.response?.data?.message.toLowerCase().includes('email not verified') ){
          setOpenModal(true);
        }
      }
    }
  );
  const _login = (data) => {
    setLoginData(data);
    mutate(data);
  };
  return {
    severity, message, openToast, setOpenToast, duration,
    loginData,
    openModal,
    setOpenModal,
    loading: isLoading,
    login: _login,
  };
}
